module.exports = __webpack_public_path__ + "img/es_Ecran 1.87169d11.png";